<button appPreventDoubleClick pButton pRipple class="p-button-outlined btnBlueColored" pTooltip="Un-cancel" tooltipPosition="left" icon="fas fa-undo" id="uncancelBtn" iconPos="left"
(debounceClick)="documentCollaborationPhase()"></button>
